import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { ProductReviewsComponentDef } from '@df/catalog-ui/review/product-reviews.component.def';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { Review } from '@df/catalog/review/review';
import { ImageModule } from '@df/module-image/image.module';
import { RatingComponent } from '@df/ui/common/rating.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { PagerComponentDef } from '@df/ui/display/pager.component.def';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Subscription } from 'rxjs';
import { ReviewsPagerComponent } from '../../review/reviews-pager.component';
import { ProductReviewsItemComponent } from './item/product-reviews-item.component';
export interface ISortOption {
    name: string;
    sortMethod: (reviews: Review[]) => Review[];
}
@Component({
    selector: 'product-reviews',
    templateUrl: './product-reviews.html',
    standalone: true,
    imports: [
        ImageModule,
        NgClass,
        ProductReviewsItemComponent,
        RatingComponent,
        ReviewsPagerComponent,
        SizeClassDirective,
        SlicePipe,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductReviewsComponent extends ProductReviewsComponentDef implements OnInit, OnDestroy, OnChanges {
    protected toggleService = inject(ToggleService);
    @Input({
        required: true
    })
    parent!: Product<IProductDataV2>;
    @Input()
    variant: 'standard' | 'modal' = 'standard';
    @Input()
    sortOption?: ISortOption;
    displayMoreReviews = true;
    offset = 0;
    pagerSize = 3;
    protected currentSortOption?: string;
    protected sortedReviews?: Review[];
    override ngOnInit() {
        /**
         * detect changes whenever any status is changed
         */
        this.subscriptions.add(this.status.subscribe(() => this._ref.detectChanges()));
        this.checkDisplayMoreReviews();
        super.ngOnInit();
        console.log('ngOnInit', this);
    }
    override ngOnChanges(): void {
        if (this.currentSortOption && this.sortOption && this.currentSortOption !== this.sortOption?.name) {
            this.sortReviews(this.sortOption);
        }
        super.ngOnChanges();
    }
    get reviewsRating(): number {
        return parseFloat(((this.parent.data?.reviews?.rating || 0) / 20).toFixed(1));
    }
    get reviewsCount(): number {
        return this.parent.data?.reviews?.count || 0;
    }
    /**
     * Reset reviews
     */
    protected override setReviews(reviews?: Review[]): void {
        super.setReviews(reviews);
        if (this.sortOption) {
            this.sortReviews(this.sortOption);
        }
    }
    protected sortReviews(sortOption: ISortOption): void {
        this.sortedReviews = this.reviews ? sortOption.sortMethod(this.reviews) || this.reviews : [];
        this.currentSortOption = sortOption.name;
        this.detectChanges();
    }
    checkDisplayMoreReviews(): void {
        this.displayMoreReviews = this.reviewsCount > this.pagerSize;
    }
    displayMore(): void {
        this.pagerSize = 6;
        this.displayMoreReviews = false;
        this._ref.detectChanges();
    }
    onPagerChange(pager: PagerComponentDef): void {
        this.offset = pager.offset;
        this._ref.detectChanges();
    }
    open(id: NToggle.TId): void {
        this.toggleService.open(id);
    }
    toggle(id: NToggle.TId): void {
        this.toggleService.toggle(id);
    }
}
